"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 27 28"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.96 14.307c0-.957-.086-1.878-.245-2.762H14v5.222h7.265a6.21 6.21 0 01-2.693 4.075v3.387h4.363c2.552-2.35 4.025-5.81 4.025-9.922z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27.5c3.645 0 6.7-1.209 8.935-3.27l-4.363-3.388c-1.21.81-2.756 1.289-4.572 1.289-3.516 0-6.492-2.375-7.554-5.566h-4.51v3.498C4.157 24.475 8.723 27.5 14 27.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.446 16.565A8.115 8.115 0 016.023 14c0-.89.153-1.755.423-2.565V7.937h-4.51A13.495 13.495 0 00.5 14c0 2.178.522 4.24 1.436 6.063l4.51-3.498z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.87c1.982 0 3.762.68 5.16 2.018l3.873-3.872C20.695 1.838 17.639.5 14 .5 8.723.5 4.157 3.525 1.936 7.937l4.51 3.498C7.508 8.245 10.484 5.869 14 5.869z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h27v27H.5z"
  })));
}

var _default = SvgGoogle;
exports["default"] = _default;